import { Button, MenuItem, Stack, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { cryptoWalletFilterSchema, type CryptoWalletFilters as FilterValues } from '../../schema/cryptoDashboard';

const defaults: FilterValues = { currency: '', state: '', merchantId: '', playerId: '', clientId: '', address: '' };
const CryptoWalletFilters = ({ onApply }: { onApply: (filters: Record<string, string | null>) => void }) => {
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FilterValues>({
    resolver: zodResolver(cryptoWalletFilterSchema),
    defaultValues: defaults,
  });
  const apply = (values: FilterValues) =>
    onApply(Object.fromEntries(Object.entries(values).map(([key, value]) => [key, value || null])));
  return (
    <Stack component='form' spacing={2} onSubmit={handleSubmit(apply)} aria-label='Static wallet filters'>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={{ flexWrap: 'wrap' }}>
        <Controller
          name='state'
          control={control}
          render={({ field }) => (
            <TextField {...field} select label='Wallet state' sx={{ minWidth: 150 }}>
              <MenuItem value=''>All states</MenuItem>
              <MenuItem value='new'>New</MenuItem>
              <MenuItem value='unknown'>Unknown</MenuItem>
              <MenuItem value='ready'>Ready</MenuItem>
            </TextField>
          )}
        />
        {(['currency', 'merchantId', 'playerId', 'clientId', 'address'] as const).map((name) => (
          <TextField
            key={name}
            {...register(name)}
            label={
              {
                currency: 'Exact currency',
                merchantId: 'Merchant ID',
                playerId: 'Player ID',
                clientId: 'Client ID',
                address: 'Exact address',
              }[name]
            }
            error={!!errors[name]}
            helperText={errors[name]?.message}
          />
        ))}
      </Stack>
      <Stack direction='row' spacing={1}>
        <Button type='submit'>Apply wallet filters</Button>
        <Button
          onClick={() => {
            reset(defaults);
            apply(defaults);
          }}
        >
          Clear wallet filters
        </Button>
      </Stack>
    </Stack>
  );
};
export default CryptoWalletFilters;
